import { LayerProps } from 'react-map-gl';

const dataLayer: LayerProps = {
  id: 'lieuucation-fill',
  type: 'fill',
  source: 'lieuucations',
  beforeId: 'waterway',
  ...{ 'source-layer': 'lieuucations' },
  paint: {
    'fill-opacity': [
      'step', // arg 1
      ['zoom'], // arg 2
      0.2, // arg 3
      6,
      0.5,
      7,
      0.2,
      10,
      0.5,
      12,
      0.2
    ]
  }
};

export default dataLayer;
